import React from 'react';

import classes from './event-item.module.css';
import { Box, Group, Text, ThemeIcon, UnstyledButton } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';

type EventItemProps = React.PropsWithChildren<{
  onClick: () => void;
  calendarItem?: boolean;
  borderColor?: string;
  id: string;
  cta?: string;
}>;

const EventItemContainer: React.FC<EventItemProps> = ({
  children,
  onClick,
  calendarItem,
  borderColor,
  id,
  cta = 'See More',
}) => (
  <UnstyledButton
    key={id}
    className={calendarItem ? classes.calendarEventButton : classes.eventButton}
    onClick={onClick}
    style={calendarItem && borderColor ? { borderLeftColor: borderColor } : undefined}
    id={id}
  >
    <Group justify="space-between">
      <Box>{children}</Box>
      {!calendarItem && (
        <Group gap={2} wrap="nowrap">
          <Text c="blue">{cta}</Text>
          <ThemeIcon c="blue" variant="white" size="sm" mt={2}>
            <IconChevronRight size="1rem" stroke={1.5} />
          </ThemeIcon>
        </Group>
      )}
    </Group>
  </UnstyledButton>
);

export default EventItemContainer;
